import ChargeOrderItem from "./chargeOrderItem";
import { Type } from "class-transformer";
import { observable } from "mobx";
import { EntityValidationRules } from "../services/validationService";
import NotificationPreferences from "./notificationPreferences";
import Payment, { PaymentType } from "./payment";
import ProposedAfterPurchaseRedirectResponse from "entities/proposedAfterPurchaseRedirectResponse";

export enum ChargeOrderStatus {
  Open = "OPEN",
  PaidBankTransfer = "PAID_BANK_TRANSFER",
  Paid = "PAID",
  Deferred = "DEFERRED",
  Failed = "FAILED",
}
export default class ChargeOrder {
  id: string;

  @observable
  emailAddress: string;

  @observable
  paymentType?: PaymentType;

  @Type(() => NotificationPreferences)
  @observable
  notificationPreferences: NotificationPreferences = new NotificationPreferences();

  @observable
  proposedPurchaseRequestId?: string;

  @Type(() => ChargeOrderItem)
  @observable
  charges: ChargeOrderItem[] = [new ChargeOrderItem()];

  @observable
  @Type(() => ProposedAfterPurchaseRedirectResponse)
  _proposedAfterPurchaseRedirect?: ProposedAfterPurchaseRedirectResponse;

  _createdAt: Date = new Date();

  @Type(() => Payment)
  @observable
  transferPayment: Payment = new Payment();

  @observable
  _termsAgreement = false;

  @observable
  @Type(() => Date)
  _earliestPossibleValidSinceDate?: Date;

  @observable
  _earliestPossibleValidSinceDaysBefore?: number;

  @observable
  _wasReopen = false;

  @observable
  _status: ChargeOrderStatus = ChargeOrderStatus.Open;

  _origin: "single" | "multiple" = "single";
}

export const ChargeOrderValidationRules: EntityValidationRules<ChargeOrder> = {
  _termsAgreement: {
    isTrue: true,
  },
  paymentType: {
    required: true,
  },
};
